<template>
  <div>
    <page-header
      :page="page"
      left-side-class="col-xl-8"
      :actions="headerActions"
      right-side-class="col-xl-4 d-flex align-items-end justify-content-end pb-2"
    />
    <filter-manager
      ref="filter"
      v-model="filter.model"
      :filters="filtersHeader"
      class="filter-manager_extended"
      @academicYear="onAcademicYearChange"
      @municipality="onMunicipalityChange"
      search-container-class="search-btn"
      @search="searchHandler()"
    />
    <div class="row my-3 mx-0">
      <div class="col-12">
        <custom-separator text="Resultados" />
      </div>
    </div>

    <custom-result-not-found
      v-if="showNotResults"
      class="mt-4 row pt-3"
      text="No hay Información Disponible."
    />

    <div v-else>
      <div v-if="isReferralType">
        <referral-row
          v-for="(item, index) in result"
          :key="index"
          :referral="item"
          :caats="filter.options.caats"
          :referral-types="filter.options.serviceTypes"
          :is-inventory-flow-enabled="isInventoryFlowEnabled"
          @open="handlerOpen"
          @close="handlerClose"
          @statusChanged="onChanged"
        />
      </div>
      <div v-else>
        <equipment-row
          v-for="(item, index) in result"
          :key="index"
          :equipment="item"
          :is-inventory-flow-enabled="isInventoryFlowEnabled"
          @open="handlerOpen"
          @close="handlerClose"
          @refresh="searchHandler"
        />
      </div>
    </div>

    <section v-if="result" class="mt-4 mx-0">
      <div class="col-12">
        <pagination
          v-if="pagination.totalItemCount > pagination.pageSize"
          :data="pagination"
          :page-size="pagination.pageSize"
          @pagination-go-page="onPageChange"
        />
      </div>
    </section>
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import Pagination from 'pagination';
import CustomSeparator from 'custom-separator';
import mixAlert from '@/mixins/alert.mixin';
import FilterManager from '@/components/common/CustomFilterManager.vue';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import locationService from '@/services/api/location.api';
import peiAtReferralType from '@/utils/constants/peiAtReferralType';
import CustomResultNotFound from 'custom-result-not-found';
import ReferralRow from './ReferralRow.vue';
import storeMixin from '@quisit/mipe-utils/mixins/storeGenerator';
import EquipmentRow from './EquipmentRow.vue';
import { getSysparameterByNames } from '@/services/api/sysparameter.api';

const types = Object.freeze({ referrals: 1, equipments: 2 });

const MODULE_NAME = 'ReferralAndEquipment';

export default {
  components: {
    FilterManager,
    PageHeader,
    Pagination,
    CustomSeparator,
    CustomResultNotFound,
    ReferralRow,
    EquipmentRow,
  },
  mixins: [mixAlert, storeMixin],
  data: () => ({
    moduleName: MODULE_NAME,
    page: {
      icon: 'fas fa-list',
      title: 'Manejo de Referidos y Equipos',
      routes: ['Asistencia Tecnológica', 'Manejo de Referidos y Equipos'],
    },
    results: [],
    filter: {
      model: {
        academicYear: null,
        provider: null,
        status: null,
        equipmentStatuses: null,
        sie: null,
        center: null,
        municipality: null,
        school: null,
        teacher: null,
        type: types.referrals,
      },
      options: {
        academicYears: [],
        providers: [],
        statuses: [],
        equipmentStatuses: [],
        centers: [],
        municipalities: [],
        schools: [],
        teachers: [],
        types: [],
      },
    },
    result: [],
    pagination: {
      count: 0,
      currentPage: 1,
      pageCount: 1,
      totalItemCount: 0,
      pageSize: 10,
    },
    activeIndex: null,
    sysParameters: [],
    isInventoryFlowEnabled: false,
  }),
  computed: {
    headerActions() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.push({ name: 'at' }),
        },
      ];
    },
    hasSieOrRequisitionNumber() {
      const value = this.filter.model.sie ?? '';
      return value.length > 0;
    },
    isReferralType() {
      return this.filter.model.type === types.referrals;
    },
    isEquipmentType() {
      return this.filter.model.type === types.equipments;
    },
    filtersHeader() {
      return [
        {
          name: 'type',
          inputName: 'type',
          component: 'CustomToggle',
          options: this.filter.options.types,
          value: this.filter.model.type,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
        },
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filter.options.academicYears,
          value: this.filter.model.academicYear,
          placeholder: 'Año Académico',
          fieldName: 'description',
          fieldKey: 'id',
          clearable: true,
          error: 'El año académico es requerido.',
          validations: !this.hasSieOrRequisitionNumber ? 'required' : '',
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.filter.options.statuses,
          value: this.filter.model.status,
          placeholder: 'Estatus del Referido',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-sm-12 col-md-3 mb-md-0 mb-2',
          classContainer: 'w-100',
          mapParentValue: this.filter.model.status == null,
        },
        {
          name: 'sie',
          component: 'CustomInput',
          value: this.filter.model.sie,
          placeholder: 'Escriba Número de Referido | Número de SIE',
          icon: 'fa fa-search orange-icon',
          leftIcon: true,
          class: 'col-12 col-sm-12 col-md-3',
          type: 'text',
        },
        {
          name: 'serviceType',
          label: 'Tipo de Referido:',
          component: 'CustomDropDown',
          value: this.filter.model.serviceType,
          options: this.filter.options.serviceTypes,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.center == null,
          isAdvanced: true,
        },
        {
          name: 'caat',
          label: 'CAAT:',
          component: 'CustomDropDown',
          options: this.filter.options.caats,
          value: this.filter.model.caat,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
          disabled: this.filter?.options?.caats?.length == 1,
        },
        {
          name: 'municipality',
          label: 'Municipio:',
          component: 'CustomDropDown',
          options: this.filter.options.municipalities,
          value: this.filter.model.municipality,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.municipality == null,
          isAdvanced: true,
          disabled: this.filter.options.municipalities.length == 1,
        },
        {
          name: 'school',
          label: 'Escuela:',
          component: 'CustomDropDown',
          options: this.filter.options.schools,
          value: this.filter.model.school,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.school == null,
          isAdvanced: true,
          disabled: this.filter.options.schools.length == 1,
        },
        {
          name: 'serviceStatus',
          label: 'Estatus del servicio:',
          component: 'CustomDropDown',
          options: this.filter.options.classificationsevicestatuses,
          value: this.filter.model.classificationsevicestatus,
          placeholder: 'Seleccione',
          class: 'col-12 col-sm-6 col-md-3 d-flex flex-column',
          fieldName: 'name',
          fieldKey: 'id',
          mapParentValue: this.filter.model.status == null,
          isAdvanced: true,
          visible: this.filter.model.type === types.referrals,
        },
        {
          name: 'equipmentStatuses',
          label: 'Estatus del equipo:',
          component: 'CustomMultiSelect',
          options: this.filter.options.equipmentStatuses,
          value: this.filter.model.equipmentStatuses,
          placeholder: 'Seleccione',
          class:
            'col-12 col-sm-6 col-md-3 d-flex flex-column equipment-statuses-multiple',
          fieldName: 'name',
          fieldKey: 'id',
          isAdvanced: true,
          visible: this.filter.model.type === types.equipments,
        },
      ];
    },
    showNotResults() {
      return this.result.length == 0;
    },
  },
  watch: {
    'filter.model.type'(newVal) {
      this.result = [];
      this.results = [];
      this.pagination = {
        count: 0,
        currentPage: 1,
        pageCount: 1,
        totalItemCount: 0,
        pageSize: 10,
      };
      this.activeIndex = null;

      //Equipment option
      if (newVal == types.equipments) {
        this.filter.options.serviceTypes = this.filter.options.serviceTypes.filter(
          (x) => x.id !== peiAtReferralType.TechnicalAssistanceServiceRequest
        );
      } else {
        this.filter.options.serviceTypes = this.originalServiceTypes;
      }
    },
  },
  async mounted() {
    await Promise.all([
      this.getAcademicYears(),
      this.getStatuses(),
      this.getEquipmentStatuses(),
      this.getServiceTypes(),
      this.getClassificationServiceStatus(),
      this.getCaats(),
      this.getInventoryParam(),
    ]);
    this.getTypes();
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async getInventoryParam() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['TechAssistanceServicesInventoryFlow'],
      });
      this.isInventoryFlowEnabled =
        data[0].staticValue && data[0].staticValue.toLowerCase() === 'true';
    },
    async onAcademicYearChange() {
      this.filter.options.schools = [];
      this.filter.options.municipalities = [];
      this.filter.model.school = null;
      this.filter.model.municipality = null;
      await this.getMunicipalities();
    },
    async onMunicipalityChange() {
      this.filter.options.schools = [];
      this.filter.model.school = null;
      await this.getSchools();
    },
    async getCaats() {
      const { data: caats } = await locationService.getCaats();
      this.filter.options.caats = caats;
      if (this.filter.options.caats.length == 1) {
        this.filter.model.caat = this.filter.options.caats[0];
      }
    },
    async getSchools() {
      const { data: schools } = await locationService.getSchools(
        this.filter.model.academicYear.id,
        this.filter.model.municipality.id
      );
      this.filter.options.schools = schools;

      if (this.filter.options.schools.length == 1) {
        this.filter.model.school = this.filter.options.schools[0];
      }
    },
    async getMunicipalities() {
      const { data: municipalities } = await locationService.getMunicipalities(
        this.filter.model.academicYear.id
      );
      this.filter.options.municipalities = municipalities;

      if (this.filter.options.municipalities.length == 1) {
        this.filter.model.municipalitiy = this.filter.options.municipalities[0];
      }
    },
    async getAcademicYears() {
      const {
        data: academicYearsList,
      } = await referralAndEquipmentsservice.getAcademicyears();
      this.filter.options.academicYears = academicYearsList;
      this.filter.model.academicYear = academicYearsList[0];
      this.onAcademicYearChange();
    },
    async getStatuses() {
      const { data } = await referralAndEquipmentsservice.getStatuses();
      this.filter.options.statuses = data;
    },
    async getEquipmentStatuses() {
      const {
        data,
      } = await referralAndEquipmentsservice.getEquipmentStatuses();
      this.filter.options.equipmentStatuses = data;
    },
    async getClassificationServiceStatus() {
      const {
        data: statuses,
      } = await referralAndEquipmentsservice.getClassificationServiceStatus();
      this.filter.options.classificationsevicestatuses = statuses;
    },
    async getServiceTypes() {
      const {
        data: serviceTypes,
      } = await referralAndEquipmentsservice.getServiceTypes();
      this.filter.options.serviceTypes = serviceTypes;
      this.originalServiceTypes = serviceTypes;
    },
    getTypes() {
      this.filter.options.types = [
        {
          text: 'Referidos',
          value: types.referrals,
          checked: this.filter.model.type == types.referrals,
        },
        {
          text: 'Equipos',
          value: types.equipments,
          checked: this.filter.model.type == types.equipments,
        },
      ];
    },
    async onPageChange(page, validate = true) {
      this.search(this.filter.model, page, validate);
      this.activeIndex = null;
    },
    async search(filters, page = 1, validate = true) {
      const isValid = validate
        ? await this.$refs.filter.$refs.formValidator.validate()
        : true;
      if (!isValid) return;

      try {
        const {
          academicYear,
          status,
          serviceStatus,
          sie,
          municipality,
          school,
          serviceType,
          caat,
        } = filters;

        const payload = {
          fiscalYearId: (academicYear || {}).id,
          statusId: (status || {}).id,
          classificationServiceStatusId: (serviceStatus || {}).id,
          caatId: (caat || {}).id,
          municipalityId: (municipality || {}).id,
          registryName: sie,
          schoolId: (school || {}).id,
          referralTypeId: (serviceType || {}).id,
          currentPage: page,
          pageSize: 10,
        };

        if (
          this.isEquipmentType &&
          this.filter.model.equipmentStatuses?.length
        ) {
          payload.equipmentStatuses = this.filter.model.equipmentStatuses.map(
            (x) => x.id
          );
        }

        const { data } = this.isReferralType
          ? await referralAndEquipmentsservice.search(payload)
          : await referralAndEquipmentsservice.searchEquipments(payload);

        this.result = data.data.map((x) => ({ ...x, isOpen: false }));
        this.pagination = {
          ...this.pagination,
          totalItemCount: data.totalItemCount,
          pageCount: data.pageCount,
          currentPage: data.currentPage,
          count: data.count,
        };
      } catch (error) {
        this.ShowToast(error.message, '', 'error');
      }
    },
    async searchHandler() {
      await this.search(this.filter.model);
      this.activeIndex = null;
    },
    handlerOpen(referral) {
      this.result
        .filter((x) => x.id !== referral.id && x.isOpen)
        .forEach((x) => (x.isOpen = false));
      referral.isOpen = true;
    },
    handlerClose(referral) {
      referral.isOpen = false;
    },
    onChanged() {
      this.searchHandler();
    },
  },
  beforeRouteEnter(_, from, next) {
    const routes = [
      'ReferralEvaluationReport',
      'RequisitionAnalysis',
      'ReferralDetails',
    ];
    next(async (vm) => {
      if (routes.includes(from.name)) {
        vm.recoveryData();
        await vm.onPageChange(1, false);
      } else {
        vm.shouldRecovery = false;
      }
    });
  },
};
</script>
